import { defineComponent, ref, onMounted } from "vue";
import { gsap } from "gsap/all";

export default defineComponent({
  props: {
    items: Array,
  },
  setup() {
    const latestNewsElement = ref(null);
    const lastScroll = ref(window.pageYOffset);
    const visible = ref(true);

    const toggleVisibility = (): void => {
      animateVisibility(!visible.value);
    };

    const animateVisibility = (status: boolean): void => {
      const element = document.querySelector(".latest_news");

      if (status) {
        if (element !== null) {
          element.classList.add("latest_news--open");
        }

        visible.value = status;
      }

      gsap.to(latestNewsElement.value, {
        xPercent: status ? -100 : 0,
        ease: "power2.out",
        duration: 0.5,
        overwrite: true,
        onComplete: function () {
          if (!status) {
            setTimeout(function () {
              if (element !== null) {
                element.classList.remove("latest_news--open");
              }

              visible.value = status;
            }, 250);
          }
        },
      });
    };

    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;

      if (!visible.value) {
        return;
      }

      if (Math.abs(currentScroll - lastScroll.value) > 15) {
        //quick scroll ->  stop hovering

        animateVisibility(false);
      }

      lastScroll.value = currentScroll;
    });

    onMounted(() => {
      // animateVisibility(true);
    });

    return { latestNewsElement, visible, toggleVisibility };
  },
});
